import GameVideoList from './GameVideoList';

export default GameVideoList;
